// 会员 101
export const MEMBER_STATUS = 101;

export enum MEMBER_PLAN_TYPE {
  STANDARD_PLAN = '1', // 普通会员
  STUDENT_PLAN = '2', // 学生会员
}
